import React, { useEffect, useRef } from "react"
import { motion, animate, useMotionValue } from "framer-motion"
import { IContentPreviewTimeBelt } from "../../../../interfaces/media/IContentPreviewCarousel"

const ContentPreviewTimeBelt = ({
    uniqueId,
    animationDuration = 5,
    autoStart = true,
    isPaused = false,
    backgroundColor = "var(--thriveGreyLight)",
    fillColor = "var(--thrivePink)",
}: IContentPreviewTimeBelt) => {
    const progress = useMotionValue(0)
    const controls = useRef<ReturnType<typeof animate> | null>(null)

    useEffect(() => {
        if (!autoStart || isPaused) return

        const current = progress.get()
        controls.current = animate(progress, 1, {
            duration: (1 - current) * animationDuration,
            ease: "linear",
        })
        return () => controls.current?.stop()
    }, [autoStart, isPaused, animationDuration])

    useEffect(() => {
        if (isPaused) {
            controls.current?.stop()
        }
    }, [isPaused])

    return (
        <div
            style={{
                width: "100%",
                height: 4,
                position: "relative",
                overflow: "hidden",
                marginTop: -4,
                background: backgroundColor,
                borderBottomLeftRadius: 6,
                borderBottomRightRadius: 6,
            }}
        >
            <motion.div
                key={uniqueId}
                style={{
                    position: "absolute",
                    inset: 0,
                    background: fillColor,
                    originX: 0,
                    scaleX: progress,
                }}
            />
        </div>
    )
}

export default ContentPreviewTimeBelt